import { Component, computed, ElementRef, HostListener, inject, signal, viewChild } from '@angular/core';
import { StylesService } from '@features/styles/styles.service';
import { Wk8PipeBackComponent } from '../wk8-pipe-back/wk8-pipe-back.component';
import { Wk8PipeFrontComponent } from '../wk8-pipe-front/wk8-pipe-front.component';

@Component({
  selector: 'wk8-input-pipe',
  templateUrl: './wk8-input-pipe.component.html',
  styleUrls: ['./wk8-input-pipe.component.css'],
  imports: [Wk8PipeBackComponent, Wk8PipeFrontComponent],
})
export class Wk8InputPipeComponent {
  // INTERNAL
  readonly _stylesService = inject(StylesService);
  // We (re)compute the border pixel sizes based on desired percenstage, since borders don't support percentage-based sizes
  readonly borderLeftPercentage = 0.5;
  readonly borderTopPercentage = 2;
  screenElement = viewChild<ElementRef<HTMLDivElement>>('screen');
  windowSize = signal({ width: window.innerWidth, height: window.innerHeight });

  @HostListener('window:resize')
  onResize() {
    this.windowSize.set({ width: window.innerWidth, height: window.innerHeight });
  }

  borderLeftPixels = computed(() => {
    this.windowSize(); // trigger recomputation on resize
    const el = this.screenElement();
    return el ? Math.floor((el.nativeElement.offsetWidth * this.borderLeftPercentage) / 100) : 0;
  });
  borderRightPixels = computed(() => {
    return this.borderLeftPixels();
  });

  borderTopPixels = computed(() => {
    this.windowSize(); // trigger recomputation on resize
    const el = this.screenElement();
    return el ? Math.floor((el.nativeElement.offsetHeight * this.borderTopPercentage) / 100) : 0;
  });
  borderBottomPixels = computed(() => {
    return this.borderTopPixels();
  });
}
